import React from 'react'
import {  Box, Button, Grid, TextField, Select, MenuItem,
  FormControl, InputLabel, Typography} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';
import HeaderBox from '../../../components/HeaderBox';
import SingleAccordion from '../../../components/SingleAccordion';
import Complaint from '../../../components/enquiry/Complaint';
import ServiceImage from '../../../components/Service/ServiceImage';
import ServiceOrder from '../../../components/Service/ServiceOrder';
import WorkAllocation from '../../../components/Service/WorkAllocation';
import WorkVerification from '../../../components/Service/WorkVerification';
import DateCalander from '../../../components/DateCalander';



const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};

function AddServiceOrder() {
  const navigate = useNavigate()
  // const [isParts, setIsParts] = useState(false)
  return (
    
    <Box mt={2}>
      <Grid container spacing={1}>
      <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> ADD SERVICE ORDER </Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
          <Button sx={buttonStyle.root} onClick={() => navigate('/add_service_order')}>Save</Button>&nbsp;
          <Button sx={buttonStyle.root} onClick={() => navigate('/service_Order')}>Cancel</Button>
          </Grid>
          </Grid>
          </Grid>
        <Grid item xs={12} mt={1}>
          <Box>
          <form>
          <Grid container spacing={1}>
              <Grid item xs={12} >
                <HeaderBox title='Service Order Details'/>
              </Grid>
              
              <Grid item xs={12}>
              <Box sx={boxStyle.root} >
                <Grid container spacing={1}>
                  <Grid item xs={1}>
                    <TextField fullWidth size='small' label= 'Estimate NO' variant="outlined"required name='Estimate NO'  disabled/>
                    </Grid>
                    <Grid item xs={1}>
                    <TextField fullWidth size='small' label= 'Service NO' variant="outlined"required name='Service NO' />
                    </Grid>
                    <Grid item xs={1.2} >
                      <DateCalander title='Service Order Date'/>
                    </Grid>
                    <Grid item xs={1.3} >
                    <FormControl fullWidth size='small' required>
                      <InputLabel id="demo-select-small-label">Service Type</InputLabel>
                      <Select labelId="demo-select-small-label" id="demo-select-small"label="Service Type">
                        <MenuItem value=""></MenuItem>
                        <MenuItem value={1}>MOT</MenuItem>
                        <MenuItem value={2}>Running Repair</MenuItem>
                        <MenuItem value={3}>General Repair</MenuItem>
                      </Select>
                    </FormControl>
                    </Grid>
                    <Grid item xs={1.5} >
                    <FormControl fullWidth size='small' required>
                      <InputLabel id="demo-select-small-label">Supervisor Allotted</InputLabel>
                      <Select labelId="demo-select-small-label" id="demo-select-small" label="Supervisor Allotted">
                        <MenuItem value=""></MenuItem>
                        <MenuItem value={4}>Supervisor 1</MenuItem>
                        <MenuItem value={5}>Supervisor 2</MenuItem>
                        <MenuItem value={6}>Supervisor 3</MenuItem>
                      </Select>
                    </FormControl>
                    </Grid>
                    <Grid item xs={1.5}>
                    <FormControl fullWidth size='small' required>
                      <InputLabel id="demo-select-small-label">Service Status</InputLabel>
                      <Select labelId="demo-select-small-label" id="demo-select-small" label="Service Status">
                        <MenuItem value=""></MenuItem>
                        <MenuItem value={7}>Under Work</MenuItem>
                        <MenuItem value={8}>Work Approval</MenuItem>
                        <MenuItem value={9}>Work Completed</MenuItem>
                      </Select>
                    </FormControl>
                    </Grid>
                  
                  <Grid item xs={2}  >
                    <TextField fullWidth size='small' label="Vechicle Aggregated Details" variant="outlined" required name='Vechicle Aggregated Details '/>
                  </Grid>
                  <Grid item xs={1.5}>
                    <TextField fullWidth size='small' label="Odometer Reading" variant="outlined" required name='Odometer Reading '/>
                  </Grid>
                    <Grid item xs={1} >
                    <TextField fullWidth size='small' label="Fuel Level" variant="outlined" required name='Fuel Level '/>
                  </Grid>
                  <Grid item xs={1.2}  >
                    <DateCalander title='Promised Delivery Date '/>
                  </Grid>
                  <Grid item xs={1.2}  >
                    <DateCalander title='Actual Delivery Date '/>
                  </Grid>
                </Grid>
              </Box>
              </Grid>
              <Grid item xs={12} >
              <SingleAccordion component={<ServiceImage/>} title='Any Dent Image, Accessories and Other Details'/>
              </Grid>
              <Grid item xs={12} >
                <SingleAccordion component={<ServiceOrder/>} title='Estimate Selection'/>
              </Grid>

              <Grid item xs={12} >
                <HeaderBox title='Owner Details' />
              </Grid>
              
              <Grid item xs={12}>
                <Box sx={boxStyle.root}>
                  <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} md={1} >
                    <TextField fullWidth size='small' label="VRM" variant="outlined" required name='VRM '/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} >
                    <TextField fullWidth size='small' label="Vechicle Make" variant="outlined" required name='Vechicle Make '/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} >
                    <TextField fullWidth size='small' label="Vechicle Model" variant="outlined" required name='Vechicle Model '/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth size='small' label="Vechicle Description" variant="outlined" required name='Vechicle Description'/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1}>
                    <TextField fullWidth size='small' label="Fuel Type" variant="outlined" required name='Fuel Type'/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1}>
                    <TextField fullWidth size='small' label="Engin No" variant="outlined" required name='Engin No'/>
                  </Grid>
                    <Grid item xs={12} sm={6} md={1}>
                      <TextField fullWidth size='small' label="Owner Name" variant="outlined" required name='owner'/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField fullWidth size='small' label="Address" variant="outlined" required name='address'/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField fullWidth size='small' label="Email ID" variant="outlined" required name='email'/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} >
                      <TextField fullWidth size='small' label="Mobile" variant="outlined" required name='mobile'/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={1}>
                    <TextField fullWidth size='small'label="Postal Code" variant="outlined" required name='Postal Code'/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField fullWidth size='small'label="Street Name" variant="outlined" required name='street'/>
                    </Grid>
                    
                    
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} >
                <SingleAccordion component={<WorkAllocation/>} title='Work Allocation'/>
              </Grid>
              <Grid item xs={12} >
                <SingleAccordion component={<WorkVerification/>}  title='Work Verification'/>
              </Grid>
              <Grid item xs={12} >
                <SingleAccordion component={<Complaint/>} title='Gate Pass-Vehicle Delivery'/>
              </Grid>
              <Grid item xs={12} >
                <SingleAccordion component={<Complaint/>} title='Suggestion To Customer'/>
              </Grid>
            </Grid> 
          </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AddServiceOrder